// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-partner{width:434px;display:flex;flex-direction:column;padding:40px;background:var(--background);box-shadow:0 2px 4px var(--background--shadow);border-radius:0.375rem}.c-partner__form{display:flex;flex-direction:column}.c-partner__error{margin-bottom:16px}.c-partner__button{margin-top:16px}\n", ""]);
// Exports
module.exports = exports;
